import type { GeoJSONFeature } from '@tmapy/mapcore';

type PolygonCoordinates = unknown[][];

const getPolygons = (geometry: GeoJSONFeature['geometry']): PolygonCoordinates[] | null => {
  if (geometry?.type === 'Polygon') return [geometry.coordinates as PolygonCoordinates];
  if (geometry?.type === 'MultiPolygon') return geometry.coordinates as PolygonCoordinates[];
  return null;
};

export function isSinglePolygonArea(features: GeoJSONFeature[]): boolean {
  if (features.length !== 1) return features.length === 0;
  const polygons = getPolygons(features[0].geometry);
  return polygons?.length === 1 && polygons[0].length === 1;
}
